import { useCallback, useEffect, useRef, useState } from 'react';

type MethodType = 'get' | 'post' | 'delete';

interface ObjectType {
	[key: string]: any;
}

interface IOptions<D = any> {
	url?: string;
	data?: ObjectType;
	method?: MethodType;
	onRequest?: () => any;
	onSuccess?: (result: D) => any;
	onError?: (xhr: XMLHttpRequest) => any;
	errMsg?: string;
	errCode?: ObjectType;
	headers?: ObjectType;
}

/**
 * [run, loading] = useAjax(options)
 * fatcher = run(params)
 */
function useAjax<D = any>(options: IOptions<D>) {
	const [result, setResult] = useState<D>();
	const [error, setError] = useState<XMLHttpRequest>();
	const [loading, setLoading] = useState(false);

	const _opthios = useRef<IOptions<D>>({
		...options,
		onRequest: () => {
			setLoading(true);
			options.onRequest?.();
		},
		onSuccess: (result: D) => {
			setResult(result);
			setLoading(false);
			options.onSuccess?.(result);
		},
		onError: (xhr: XMLHttpRequest) => {
			setLoading(false);
			setError(xhr);
			options.onError?.(xhr);
		},
	});

	useEffect(() => {
		_opthios.current = options;
	}, [options]);

	const getOptions = useCallback(
		() => ({
			..._opthios.current,
			// headers: {
			// 	Authorization: `Bearer ${accessToken}`,
			// },
			onRequest: () => {
				setLoading(true);
				_opthios.current.onRequest?.();
			},
			onSuccess: (result: D) => {
				setResult(result);
				setLoading(false);
				_opthios.current.onSuccess?.(result);
			},
			onError: (xhr: XMLHttpRequest) => {
				setLoading(false);
				setError(xhr);
				_opthios.current.onError?.(xhr);
			},
		}),
		[]
	);

	const run = useCallback(
		(data?: ObjectType) => {
			const options = getOptions();
			const ajax = new _Ajax({
				...options,
				data: {
					...options.data,
					...data,
				},
			});
			ajax.send();
			return ajax;
		},
		[getOptions]
	);

	return [run, loading, result, error] as const;
}

export { useAjax };
